export default from './PageError.js';



// WEBPACK FOOTER //
// ./src/components/Errors/PageError/index.js